import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function YoutubeVideoCardAlarmAreas() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed
                    id="8O7YkAnOSRs"
                    title="Security Camera with Wi-Fi Enterprise | Set up with Synology RADIUS Server & OpenWRT Router!"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="WiFi Enterprise"
              footer={
                <EuiText>
                  <p>Security Camera with Wi-Fi Enterprise | Set up with Synology RADIUS Server & OpenWRT Router!</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
